import { createSelector } from '@ngrx/store';
import { selectFilterState } from '../filter.selectors';
import { FilterState, SortState } from '@immosky/types';

export const selectSortState = createSelector(
  selectFilterState,
  (state: FilterState) => state.sort
);

export const selectSort = createSelector(
  selectSortState,
  (state: SortState) => state.sort
);
